import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

export default {
  ValidateForm(form, message){
    if(!form.Comment){
      toast.warning(message.ERROR.MODEL.COMMENT.FORM.VALIDATION.COMMENT_EMPTY)
      return false
    } 
    return true
  },

  ValidateFormNote(form, message){
    if(!form.title) {
      toast.warning(message.ERROR.MODEL.NOTE.FORM.VALIDATION.TITLE_EMPTY)
      return false
    } else if(!form.description) {
      toast.warning(message.ERROR.MODEL.NOTE.FORM.VALIDATION.DESCRIPTION_EMPTY)
      return false
    }
    return true
  },

  ValidateFormRequestMaintenance(form, message) {
    if(!form.Asset){
      toast.warning(message.ERROR.EMPTY.ASSET)
      return false
    } else if (!form.Service) {
      toast.warning(message.ERROR.EMPTY.MAINTENANCE)
      return false
    } else if (!form.Description){
      toast.warning(message.ERROR.EMPTY.DESCRIPTION)
      return false
    } 
    return true
  },

  ValidateFormBooking(form) {
    if(!form.Site){
      toast.warning("Site is Empty!")
      return false
    } else if (!form.Location) {
      toast.warning("Location is Empty!")
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/form.js